import { render, staticRenderFns } from "./FacturaCompraDetallesList.vue?vue&type=template&id=73645a1c&scoped=true&"
import script from "./FacturaCompraDetallesList.vue?vue&type=script&lang=js&"
export * from "./FacturaCompraDetallesList.vue?vue&type=script&lang=js&"
import style0 from "./FacturaCompraDetallesList.vue?vue&type=style&index=0&id=73645a1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73645a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSnackbar,VTextField})
